/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentServiceabilityAPI
 * @hideconstructor
 * @classdesc API class that is used to return widget serviceability information
 */
define([], () => {
	class ContentServiceabilityAPI {
		/**
		 * @public
		 * @function ContentServiceabilityApi#getContentInfo
		 * @description get content info
		 */
		getContentInfo() {}

		/**
		 * @public
		 * @function ContentServiceabilityApi#showInfo
		 * @description display an overlay with info on the DOM of a content
		 */
		showInfo() {}

		/**
		 * @public
		 * @function ContentServiceabilityApi#hideInfo
		 * @description hide an overlay with info on the DOM of a content
		 */
		hideInfo() {}

		/**
		 * @public
		 * @function ContentServiceabilityAPI#isInfoVisible
		 * @description check if there is an overlay with info on a content
		 * @return {boolean} True indicates the info is being displayed on DOM,
		 * false otherwise.
		 */
		isInfoVisible() {}
	}

	return ContentServiceabilityAPI;
});
